import './scss/pages/archive-events.scss';
import { searchFilters } from './js/components/search-filters.js';

window.addEventListener( 'DOMContentLoaded', () => {

	searchFilters();

} );
